import { grey, purple } from "@mui/material/colors"

export default {
  palette: {
    type: "light",
    primary: {
      main: "#FF7F50",
      dark: "#ff5a1d",
    },
    secondary: {
      light: "#f2f2f2",
      main: "#f5f5f5",
      dark: "#c2c2c2",
      contrastText: "#000",
    },
    otherpurple: purple[500],
    nicepurple: "#6772e5",
    darkpurple: "#603ce6",
    text: {
      text: grey,
      icon: grey[500],
    },
    background: {
      default: "#ffffff",
      paper: "#fafafa"
    },
    grey: grey
  },
  typography: {
    fontFamily: [
      "Rubik",
    ].join(","),
  },
  contentWidth: "90%",
  drawerWidth: 220,
  // shadows: ["none"],
  shadows: Array(25).fill("none")

}
